import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  "aria-live": "assertive",
  class: "fixed z-999 font-body bottom-24p left-24p"
}
const _hoisted_2 = { class: "flex-1 text-white flex items-center" }
const _hoisted_3 = { class: "text-16 font-normal" }
const _hoisted_4 = { class: "ml-12p flex-shrink-0 flex" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Close", -1)
const _hoisted_6 = { class: "flex-1 text-white flex items-center" }
const _hoisted_7 = { class: "text-16 font-normal" }
const _hoisted_8 = { class: "ml-12p flex-shrink-0 flex" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_component = _resolveComponent("icon-component")

  return (_openBlock(), _createBlock(_Teleport, { to: "#toast" }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, {
        name: "slide-fade-right",
        tag: "ul"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.toasts, (toast) => {
            return (_openBlock(), _createBlock("div", {
              class: ["px-16p flex items-center w-max rounded-8p mt-10p mr-auto", [toast.type === 'basic' ? 'bg-neutrals-900 py-14p' : 'bg-error-3 py-16p']],
              key: toast.id
            }, [
              _createVNode("div", _hoisted_2, [
                (toast.icon)
                  ? (_openBlock(), _createBlock(_component_icon_component, {
                      key: 0,
                      name: toast.icon,
                      color: toast.iconColor,
                      class: "mr-8p"
                    }, null, 8, ["name", "color"]))
                  : _createCommentVNode("", true),
                _createVNode("p", _hoisted_3, _toDisplayString(toast.title), 1),
                (toast.btnLabel)
                  ? (_openBlock(), _createBlock("button", {
                      key: 1,
                      onClick: toast.btnFunction,
                      class: "ml-24p mr-16p text-14 font-medium focus:outline-none"
                    }, _toDisplayString(toast.btnLabel), 9, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_4, [
                _createVNode("button", {
                  onClick: ($event: any) => (_ctx.removeToast(toast.id)),
                  class: "bg-transparent inline-flex focus:outline-none"
                }, [
                  _hoisted_5,
                  _createVNode(_component_icon_component, {
                    name: "times",
                    color: "white"
                  })
                ], 8, ["onClick"])
              ])
            ], 2))
          }), 128)),
          (_ctx.toastSingle)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: ["px-16p flex items-center w-max rounded-8p mt-10p mr-auto", [_ctx.toastSingle.type === 'basic' ? 'bg-neutrals-900 py-14p' : 'bg-error-3 py-16p']]
              }, [
                _createVNode("div", _hoisted_6, [
                  (_ctx.toastSingle.icon)
                    ? (_openBlock(), _createBlock(_component_icon_component, {
                        key: 0,
                        name: _ctx.toastSingle.icon,
                        color: _ctx.toastSingle.iconColor,
                        class: "mr-8p"
                      }, null, 8, ["name", "color"]))
                    : _createCommentVNode("", true),
                  _createVNode("p", _hoisted_7, _toDisplayString(_ctx.toastSingle.title), 1),
                  (_ctx.toastSingle.btnLabel)
                    ? (_openBlock(), _createBlock("button", {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toastSingle.btnFunction && _ctx.toastSingle.btnFunction(...args))),
                        class: "ml-24p mr-16p text-14 font-medium focus:outline-none"
                      }, _toDisplayString(_ctx.toastSingle.btnLabel), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeToastSingle && _ctx.removeToastSingle(...args))),
                    class: "bg-transparent inline-flex focus:outline-none"
                  }, [
                    _hoisted_9,
                    _createVNode(_component_icon_component, {
                      name: "times",
                      color: "white"
                    })
                  ])
                ])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}